import { render, staticRenderFns } from "./user-widget.vue?vue&type=template&id=5a55e4a0"
import script from "./user-widget.vue?vue&type=script&lang=ts"
export * from "./user-widget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports